module.exports = __webpack_public_path__ + "static/media/BSI_logo.a609d226.png";